import {
    trigger,
    transition,
    style,
    query,
    group,
    animateChild,
    animate,
    keyframes,
    state,
  } from '@angular/animations';

const optional = { optional: true };

export const alertSummuryFader =
  trigger('alertSummuryAnimations', [
    transition('* <=> *', [
      query(':enter', [
        style({ opacity: 0 }),                        // before animation
        animate('.3s linear', style({ opacity: 1})),   // animation
      ], optional),
      query(':leave', [
        style({ opacity: 1 }),
        animate('.3s linear', style({ opacity: 0 })),
      ], optional)
    ]),
]);


// export const fader =
//   trigger('routeAnimations', [
//     transition('* <=> *', [
//       // Set a default  style for enter and leave
//       query(':enter, :leave', [
//         style({
//           position: 'absolute',
//           left: 0,
//           width: '100%',
//           opacity: 0,
//           transform: 'scale(0) translateY(100%)',
//         }),
//       ], optional),
//       // Animate the new page in
//       query(':enter', [
//         animate('600ms ease', style({ opacity: 1, transform: 'scale(1) translateY(0)' })),
//       ], optional)
//     ]),
// ]);

export const routeSlider =
  trigger('routeAnimations', [
    transition('* <=> *', [
      // Set a default  style for enter and leave
    /* order */
    /* 1 */ query(':enter, :leave', style({ position: 'fixed', width: '100%' })
    , optional),
    /* 2 */ group([  // block executes in parallel
      query(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('0.4s ease-in-out', style({ transform: 'translateX(0%)' }))
      ], optional),
      query(':leave', [
        style({ transform: 'translateX(0%)' }),
        animate('0.4s ease-in-out', style({ transform: 'translateX(-100%)' }))
      ], optional),
    ]),
  ]),
]);

export const routeNestedSlider =
  trigger('routeNestedAnimations', [
    transition('* => slideinAnimTransition', [
      group([
        query('.backdrop', [
          style({ opacity: 0 }),
          animate('.225s ease', style({ opacity: 1 }))
        ], { optional: true }),
        query('.slidein', [
          style({ transform: 'translateX(100%)' }),
          animate('.375s 0.4s ease-in', style({ transform: 'translateX(0)' }))
        ]),
        query('@*', animateChild({ delay: '.3s' }), { optional: true })
      ])
    ]),
    transition('slideinAnimTransition => *', [
      query('@*', animateChild(), { optional: true }),
      group([
        query('.backdrop', [
          style({ opacity: 1 }),
          animate('.225s ease', style({ opacity: 0 }))
        ], { optional: true }),
        query('.slidein', [
          style({ transform: 'translateX(0)' }),
          animate('.225s ease-out', style({ transform: 'translateX(100%)' }))
        ])
      ])
    ])
  ]);
